import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

interface Props {
  title: React.ReactNode;
  message: React.ReactNode;
  onClose: () => void;
}
const TitleMessageDialog: React.FC<Props> = ({ title, message, onClose }) => (
  <Dialog
    open
    onClose={onClose} // When user clicks outside modal close it
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
    maxWidth="xs"
    fullWidth
  >
    <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
    <DialogContent>
      <DialogContentText id="alert-dialog-description">{message}</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button variant="text" onClick={onClose} color="primary" autoFocus>
        <FormattedMessage defaultMessage="Close" />
      </Button>
    </DialogActions>
  </Dialog>
);

export default React.memo(TitleMessageDialog);
